import React from 'react';
import { connect } from 'react-redux';
import { CATERING_PACKAGE_FORM } from '../../../app-main/components/reduxForms/constants/formNames';
import CateringAddOns from '../data/catering-add-ons.json';
import { CateringAddOnBartendingField } from './CateringAddOnBartendingField';
import { CateringAddOnCounterField } from './CateringAddOnCounterField';
import { CateringAddOnField } from './CateringAddOnField';
import { CateringAddOnRadioField } from './CateringAddOnRadioField';

const CateringAddOnsFormCmp = ({ dispatch, formValues, numberOfGuests }) => {
  // filter out bartending add-on if the number of guests is less than 40
  const filteredAddOns = CateringAddOns.filter(
    (addOn) => numberOfGuests >= 40 || addOn.id !== 'bartending'
  );

  return (
    <form className="catering-addons-form">
      <div className="catering-addons-form-inner">
        {filteredAddOns.map((addOn, i) => (
          <>
            <CateringAddOnField
              key={addOn.id}
              addOn={addOn}
              dispatch={dispatch}
              formValues={formValues}
              numberOfGuests={numberOfGuests}
            >
              {addOn.id === 'bartending' && (
                <CateringAddOnBartendingField
                  numberOfGuests={numberOfGuests}
                  addOn={addOn}
                  formValues={formValues}
                />
              )}

              {addOn.options?.length > 0 && (
                <CateringAddOnRadioField
                  addOn={addOn}
                  dispatch={dispatch}
                  formValues={formValues}
                />
              )}

              {addOn.counters?.length > 0 && (
                <div className="catering-addons-counters-wrap">
                  {addOn.counters.map((counter) => (
                    <CateringAddOnCounterField
                      key={counter.name}
                      addOn={addOn}
                      counter={counter}
                      dispatch={dispatch}
                      formValues={formValues}
                    />
                  ))}
                </div>
              )}
            </CateringAddOnField>

            {i < filteredAddOns.length - 1 && <hr />}
          </>
        ))}
      </div>
    </form>
  );
};

const mapStateToProps = ({ form }) => ({
  formValues: form[CATERING_PACKAGE_FORM]?.values
});

export const CateringAddOnsForm = connect(mapStateToProps)(
  CateringAddOnsFormCmp
);
